<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR EVENTO' : 'NOVO EVENTO DO CALENDÁRIO'" titleIcon="fas fa-calendar-plus">

            <div v-if="!carregado" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="Marque como sugestão da SMED quando o evento depender do aceite de cada escola. Enquanto pendente, ele não altera os dias letivos de ninguém."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Nome do evento" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="191" placeholder="Ex.: Semana Pedagógica"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Tipo" prop="tipo" :rules="[$requiredChange]">
                            <el-select v-model="dados.tipo" style="width: 100%;">
                                <el-option v-for="t in tipos" :key="t" :value="t" :label="rotuloTipo(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Período letivo" prop="periodo_letivo_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.periodo_letivo_id" style="width: 100%;">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Data inicial" prop="data_inicio" :rules="[$requiredChange]">
                            <el-date-picker v-model="dados.data_inicio" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width: 100%;" placeholder="dd/mm/aaaa"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Data final" prop="data_fim" :rules="[$requiredChange]">
                            <el-date-picker v-model="dados.data_fim" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width: 100%;" placeholder="dd/mm/aaaa"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="14">
                        <el-form-item label="Público-alvo">
                            <el-checkbox-group v-model="dados.publico_alvo">
                                <el-checkbox v-for="p in publicos" :key="p" :label="p" border size="small">{{ rotuloPublico(p) }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="É dia letivo?">
                            <el-select v-model="dados.dia_letivo" style="width: 100%;">
                                <el-option :value="true" label="Sim — conta como dia letivo"></el-option>
                                <el-option :value="false" label="Não"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="É dia trabalhado?">
                            <el-select v-model="dados.dia_trabalhado" style="width: 100%;">
                                <el-option :value="true" label="Sim"></el-option>
                                <el-option :value="false" label="Não"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Obrigatório?">
                            <el-select v-model="dados.obrigatorio" style="width: 100%;">
                                <el-option :value="true" label="Sim"></el-option>
                                <el-option :value="false" label="Não"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Sugestão da SMED?">
                            <el-select v-model="dados.sugerido_smed" style="width: 100%;">
                                <el-option :value="false" label="Não — vale direto"></el-option>
                                <el-option :value="true" label="Sim — depende de aceite"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="Ativo"></el-option>
                                <el-option :value="false" label="Inativo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Abrangência">
                            <el-select v-model="dados.escopo" style="width: 100%;" @change="dados.escopo_id = null">
                                <el-option value="rede" label="Toda a rede"></el-option>
                                <el-option value="instituicao" label="Uma escola"></el-option>
                                <el-option value="matriz_curricular" label="Uma matriz curricular"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" v-if="dados.escopo === 'instituicao'">
                        <el-form-item label="Escola">
                            <el-select v-model="dados.escopo_id" filterable style="width: 100%;">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" v-if="dados.escopo === 'matriz_curricular'">
                        <el-form-item label="Matriz curricular">
                            <el-select v-model="dados.escopo_id" filterable style="width: 100%;">
                                <el-option v-for="m in matrizes" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Descrição">
                    <el-input v-model="dados.descricao" type="textarea" :rows="3"></el-input>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/evento-calendario"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO C — itens 37, 38, 39 e 42. Interface para `api/evento-calendario`. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        carregado: false,
        tipos: [], publicos: [], instituicoes: [], matrizes: [],
        dados: {
            nome: '', descricao: '', tipo: '', data_inicio: '', data_fim: '',
            dia_letivo: false, dia_trabalhado: true, obrigatorio: false,
            publico_alvo: [], escopo: 'rede', escopo_id: null,
            periodo_letivo_id: null, sugerido_smed: false, situacao: true
        }
    }),
    computed: {
        
        /**
         * Esconder o botão NÃO é segurança — o backend continua sendo a autoridade.
         * Isso só evita oferecer ao perfil Consulta uma ação que a API vai recusar.
         */
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        this.dados.periodo_letivo_id = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/evento-calendario/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            const d = r.data || {}
            this.tipos = d.tipos || []
            this.publicos = d.publicos || []
        }).catch(() => {})

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matriz-curricular/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.matrizes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        if (this.modoEdicao) this.carregarRegistro()
        else this.carregado = true
    },
    methods: {
        carregarRegistro () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/evento-calendario/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/evento-calendario')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
                this.dados.publico_alvo = reg.publico_alvo || []
                this.dados.data_inicio = String(reg.data_inicio || '').substring(0, 10)
                this.dados.data_fim = String(reg.data_fim || '').substring(0, 10)
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        rotuloTipo (t) {
            const r = { feriado_nacional: 'Feriado nacional', feriado_estadual: 'Feriado estadual',
                feriado_municipal: 'Feriado municipal', recesso: 'Recesso', ponto_facultativo: 'Ponto facultativo',
                paralisacao: 'Paralisação', evento_escolar: 'Evento escolar', avaliacao: 'Avaliação',
                formacao: 'Formação', reuniao: 'Reunião', outros: 'Outros' }
            return r[t] || t
        },
        rotuloPublico (p) {
            return { alunos: 'Alunos', professores: 'Professores', gestores: 'Gestores',
                     pais: 'Pais', servidores: 'Servidores' }[p] || p
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/evento-calendario/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/evento-calendario/store`

                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Evento salvo.', type: 'success' })
                    this.$router.push('/admin/evento-calendario')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
